import React, { createContext, useContext, useState, useMemo, useCallback, useEffect } from "react";
import { translations, t as translateFn } from "@/i18n/translations";

const LanguageContext = createContext(null);

const STORAGE_KEY = "primo_lang";

export function LanguageProvider({ children }) {
  const [lang, setLangState] = useState(() => {
    try {
      const stored = localStorage.getItem(STORAGE_KEY);
      if (stored && translations[stored]) return stored;
    } catch (_) {}
    return "pt-PT";
  });

  const setLang = useCallback((code) => {
    if (!translations[code]) return;
    setLangState(code);
    try { localStorage.setItem(STORAGE_KEY, code); } catch (_) {}
  }, []);

  const t = useCallback((path, params) => translateFn(lang, path, params), [lang]);

  const value = useMemo(() => ({ lang, setLang, t }), [lang, setLang, t]);

  useEffect(() => {
    document.documentElement.lang = lang;
  }, [lang]);

  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
}

export function useI18n() {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useI18n must be used within LanguageProvider");
  return ctx;
}
